import { filter, take } from "rxjs";
import { widgetStore$ } from "@/state/observable";
import {
  peekReloginIntent,
  consumeReloginIntent,
} from "@/utils/reloginHelpers";
import { redirectTo } from "@/utils";

export const startReloginContinuationEffect = () => {
  const intent = peekReloginIntent();
  if (!intent) return () => {};

  if (import.meta.env.DEV || window.__KCW_DEBUG__) {
    console.log("[telekomId] relogin intent detected", intent);
  }

  const sub = widgetStore$
    .pipe(
      filter((s) => s.state.ready),
      filter((s) => Boolean(s.state.urls.loginUrl)),
      filter((s) => !intent.channel || intent.channel === s.state.clientId),
      take(1),
    )
    .subscribe((s) => {
      consumeReloginIntent();
      redirectTo(s.state.urls.loginUrl!, "top");
    });

  return () => sub.unsubscribe();
};
